import HeroHome from './HeroHome'
export default HeroHome
